import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/FarmingBaseEXP.json";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";
import { handleEmit } from "src/contract-logic/logic";

const { NFT_FARMING_BASE_EXP } = getCurrentContractAddresses();

var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_FARMING_BASE_EXP);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_FARMING_BASE_EXP);
  return contractSender;
}

async function getStakingNFTinALevel(accountAddress, level) {
  try {
    const res = await getContractReader().methods.getStakingNFTinALevel(accountAddress, level).call();
    return res;
  } catch (err) {
    console.error(err);
    return [];
  }
}

async function stake(dispatch, ids, level, accountAddress) {
  const emit = getContractSender().methods.stake(ids, level).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Stake heuristic");
  return await emit;
}

async function getTotalRewardsBalance(arrayId) {
  try {
    const res = await getContractReader().methods.getTotalRewardsBalance(arrayId).call();
    return res.toString();
  } catch (err) {
    console.error(err);
    return 0;
  }
}

async function redeemAndClaim(dispatch, ids, level, accountAddress) {
  const emit = getContractSender().methods.redeemAndClaim(ids, level).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Unstaking");
  return await emit;
}

async function poolInfos(level) {
  const res = await getContractReader().methods.poolInfos(level).call();
  return { ...res, nftCount: parseInt(res.nftCount), totalValue: parseInt(res.totalValue) };
}

async function nftInfos(id) {
  const res = await getContractReader().methods.nftInfos(id).call();
  return res;
}

async function getEmissionPerSecond(id) {
  const res = await getContractReader().methods.getEmissionPerSecond(id).call();
  return res.toString();
}

async function getExpEarnedAndValueEarned(id) {
  const res = await getContractReader().methods.getExpEarnedAndValueEarned(id).call();
  return res;
}

async function polishNFT(dispatch, ids, level, accountAddress) {
  const emit = getContractSender().methods.polishNFT(ids, level).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Polishing");
  return await emit;
}

async function claimReward(dispatch, ids, level, accountAddress) {
  const emit = getContractSender().methods.claimReward(ids, level).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Claim Reward");
  return await emit;
}

export default {
  ADDRESS: NFT_FARMING_BASE_EXP,
  ABI,
  getStakingNFTinALevel,
  redeemAndClaim,
  poolInfos,
  stake,
  getTotalRewardsBalance,
  nftInfos,
  getExpEarnedAndValueEarned,
  polishNFT,
  claimReward,
  getEmissionPerSecond,
};
